import React from 'react'
import { BrowserWindow, ExampleSearchForm } from '..'
import _ from 'lodash'
import SyntaxHighlighter from 'react-syntax-highlighter/light'
import dark from 'react-syntax-highlighter/dist/styles/hljs/dark'
import jsonStringify from '@aitodotai/json-stringify-pretty-compact'
import { stripIndent } from 'common-tags/es'
import * as styles from './styles'

const createCodeSnippet = (text) => {
  return stripIndent`
    $ curl -X POST \\
      https://smart-search.api.aito.ai/api/v1/_query \\
      -H 'content-type: application/json' \\
      -d '
      {
        "from": "documentation",
        “orderBy": {
          “$similarity": {
            "analyzedText": "${text}"
          }
        },
        "limit": 2
      }'
    `
}

function createResponseSnippet(content) {
  const result1Header = [
    content.result1HeaderKeyword,
    content.result1HeaderTail,
  ].join('')
  const result1Text = [
    content.result1TextBefore,
    content.result1TextKeyword,
    content.result1TextAfter,
  ].join('')

  const result2Header = [
    content.result2HeaderKeyword,
    content.result2HeaderTail,
  ].join('')
  const result2Text = [
    content.result2TextBefore,
    content.result2TextKeyword,
    content.result2TextAfter,
  ].join('')

  const response = {
    total: 5,
    hits: [
      { title: result1Header, description: result1Text },
      { title: result2Header, description: result2Text },
    ]
  }

  return jsonStringify(response, { maxLength: Infinity, maxNesting: 1 })
}

const backendSyntaxStyle = _.merge({}, _.cloneDeep(dark), {
  hljs: {
    background: 'none',
    overflow: 'hidden',
    overflowX: 'hidden',
    overflowY: 'hidden',
    padding: 0,
    margin: '0.5rem 0',
  }
})

class AnimatedWindowStack extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      backendVisible: false,
      typingText: ''
    }
  }

  componentDidMount() {
    const { props } = this
    this.type(props.searchFormContent.inputText, 0)
  }

  componentWillUnmount() {
    if (this.typeTimeout) {
      clearTimeout(this.typeTimeout)
    }

    if (this.resetTypingTimeout) {
      clearTimeout(this.resetTypingTimeout)
    }
  }

  type = (text, index) => {
    if (text.length <= index) {
      this.setState({ typingText: text }, () => this.resetTyping())
      return
    }

    this.setState({ typingText: text.substring(0, index + 1) })

    const rand = Math.floor(Math.random() * (100))
    this.typeTimeout = setTimeout(() => { this.type(text, index + 1) }, rand)
  }

  resetTyping = () => {
    const { state, props } = this

    this.resetTypingTimeout = setTimeout(
      () => this.setState(
        {
          typingText: '',
          backendVisible: !state.backendVisible
        },
        () => this.type(props.searchFormContent.inputText, 0)
      ),
      3000
    )
  }

  render() {
    const { state, props } = this
    const { backendVisible, typingText } = state
    const { indicator, searchFormContent } = props
    return (
      <styles.Container>
        <styles.BrowserContainer>
          <styles.BackendWindow visible={backendVisible}>
            <BrowserWindow topBarBgColor="#454545" contentBgColor="#393939" titleColor="#eee" title={indicator.backend}>
              <styles.QueryBox>
                <SyntaxHighlighter language="bash" style={backendSyntaxStyle}>
                  {createCodeSnippet(typingText)}
                </SyntaxHighlighter>
                <SyntaxHighlighter language="javascript" style={backendSyntaxStyle}>
                  {createResponseSnippet(searchFormContent)}
                </SyntaxHighlighter>
              </styles.QueryBox>
            </BrowserWindow>
          </styles.BackendWindow>
          <styles.FrontendWindow visible={!backendVisible}>
            <BrowserWindow title={indicator.frontend}>
              <ExampleSearchForm inputText={typingText} content={searchFormContent} />
            </BrowserWindow>
          </styles.FrontendWindow>
        </styles.BrowserContainer>
      </styles.Container>
    )
  }
}

export default AnimatedWindowStack
